 
import React from "react";
import { Button, Link, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  AddOutlined,
  RequestQuote,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../../hooks";
import { LoadState } from "../../../../../../../constants/enums";
import { IAutomobileDriverActivity } from "../../../../../../../redux/automobileDriver/automobileDriver.types";
import { StandardTableActions } from "../../../../../../../components/StandardTableActions/StandardTableActions";
import {
  clearAutomobileActivityTask,
  fetchAutomobileDriverTasksListAsync,
} from "../../../../../../../redux/automobileDriver/automobileDriverActions";
import { useTableV2State } from "../../../../../../../components/TableV2/hooks/useTableV2State";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../../../../../components/TableV2/interfaces/IDataTableV2Props";
import { StatusRenderer } from "../../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { PageTitleBar } from "../../../../../../../components/PageTitleBar/PageTitleBar";
import { DataTableV2 } from "../../../../../../../components/TableV2/DataTableV2";
import { LeadDialogTable } from "../../../LeadDialogTable/LeadDialogTable";

export const AutomobileDriverActivityList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { driverActivityList, driverActivityListLoading } = useSelector(
    (storeState: IStoreState) => storeState.automobile.driver.driverActivity
  );
  const [openFile, setOpenFile] = React.useState(false);
  const dispatch = useDispatchWrapper();


  const {
    state: { columnsConfig,
      dense },

    setColumnVisibility,
 
    onDenseToggle, } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "allTimes",
      selectedTab: "-1",
    },
  });

  const handleCreate = () => {
    navigate(
      `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/activity-task`
    );
  };

  const fetchList = () => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileDriverTasksListAsync(customerPolicyId));
    }
  };

  React.useEffect(() => {
    fetchList();

    return () => {
      dispatch(clearAutomobileActivityTask());
    };
  }, [customerPolicyId]);

  const automobileDriverTableProps: IDataTableV2Props = {
    isPagination: false,
    isDataLoading: driverActivityListLoading === LoadState.InProgress,
    tableCommandBarProps: {
      preDefinedPlugins: {
        columnVisibility: {
          columnVisibility: columnsConfig.columnVisibility,
          onChange: setColumnVisibility,
        },
        refresh: {
          onClick: fetchList,
        },
      },
      leftItems: {},
      rightItems: {
        // customPlugins: [
        //   {
        //     key: "status",
        //     onRender: () => (
        //       <ControlledCustomSelect
        //         fullWidth
        //         value={status}
        //         name="status"
        //         onChange={(e) => setStatus(e.target.value as "ACTIVE")}
        //         placeholder="Select one"
        //         displayEmpty
        //         options={[{label: "Both", value: "-1"},...COMMON_STATUS]}
        //       />
        //     ),
        //   },
        // ],
      },
    },
    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileDriverActivity) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/activity-task/${row.incremental_number}`
                );
              }}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IAutomobileDriverActivity) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        // exportCellWidth: 15,
        onRowCellRender: (value, row: IAutomobileDriverActivity) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/activity-task/${row.incremental_number}`
                );
              }}
            >
              {row.incremental_number}
            </Link>
          );
        },
      },
      {
        key: "driver_name",
        headerName: "Driver Name",
        fieldName: "driver_name",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
        onRowCellRender: (value, row: IAutomobileDriverActivity) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/automobile-policy/${customerId}/driver-tab/${customerPolicyId}/activity-task/${row.incremental_number}`
                );
              }}
            >
              {row.driver_name}
            </Link>
          );
        },
      },
      {
        key: "license_number",
        headerName: "License Number",
        fieldName: "license_number",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 20,
      },
      {
        key: "policy_number",
        headerName: "Policy Number",
        fieldName: "policy_number",
        renderType: DataTableV2RowRenderType.TEXT,
        // exportCellWidth: 30,
      },

      {
        key: "business_reason",
        headerName: "Business Reason",
        fieldName: "business_reason",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "transaction_type",
        headerName: "Transaction Type",
        fieldName: "transaction_type",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.CHIP_WARNING,
      },
      {
        key: "report_requested",
        headerName: "Report Requested",
        fieldName: "report_requested",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
      {
        key: "request_status",
        headerName: "Request Status",
        fieldName: "request_status",
        // exportCellWidth: 25,
        renderType: DataTableV2RowRenderType.TEXT,
      },
    ],
    rows: driverActivityList,
      dense: dense,
    onDenseToggle: onDenseToggle,};

  const handleComplete = () => {
    fetchList();
    setOpenFile(false);
  };

  return (
    <>
      <PageTitleBar
        heading="Insurance Reports"
        rightHeading={
          <Stack direction={"row"} spacing={1}>
            <Button
              variant="contained"
              disableElevation
              onClick={() => setOpenFile(true)}
              endIcon={<RequestQuote />}
            >
              Data From Lead
            </Button>
            <Button
              variant="contained"
              onClick={handleCreate}
              startIcon={<AddOutlined />}
            >
              Create
            </Button>
          </Stack>
        }
      />
      <DataTableV2 {...automobileDriverTableProps} />
      {openFile && (
        <LeadDialogTable
          open={openFile}
          onComplete={handleComplete}
          type={"automobile"}
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          onClose={() => setOpenFile(false)}
        />
      )}
    </>
  );
};
